export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
export const MAIN_DOMAIN = process.env.REACT_APP_MAIN_DOMAIN;
export const CLOUDFRONT_SECURE_PROXY =
  process.env.REACT_APP_CLOUDFRONT_SECURE_PROXY;
export const SUBTITLES_SUBDOMAIN = process.env.REACT_APP_SUBTITLES_SUBDOMAIN;


export const SCREENER_PARENT_SECTION = parseInt(process.env.REACT_APP_SCREENER_PARENT_SECTION);
export const SCREENER_START = parseInt(process.env.REACT_APP_SCREENER_START);
export const SCREENER_END = parseInt(process.env.REACT_APP_SCREENER_END);
export const ACTIVITY_SCREENER_BASELINE = parseInt(process.env.REACT_APP_ACTIVITY_SCREENER_BASELINE);

//export const SCREENER_PARENT_SECTION_ARRAY = process.env.REACT_APP_SCREENER_PARENT_SECTION_ARRAY.split(',').map(Number);
export const SCREENER_END_PLUS = parseInt(process.env.REACT_APP_SCREENER_END_PLUS);
export const SCREENER_KC_MIN_PLUS = parseInt(process.env.REACT_APP_SCREENER_KC_MIN_PLUS);

export const SENTRY_TRACE_RATE = process.env.REACT_APP_SENTRY_TRACE_RATE;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const courseStatuses = {
  NOT_STARTED: 'not_started',
  COMPLETED: 'completed',
  IN_PROGRESS: 'in_progress',
};

export const PRODUCT_NAME = process.env.REACT_APP_PRODUCT_NAME || 'Begin Bright';
export const COMPANY_LEGAL_NAME = process.env.REACT_APP_COMPANY_LEGAL_NAME || 'Begin Bright LLC';
export const PRODUCT_SUPPORT_EMAIL = process.env.REACT_APP_PRODUCT_SUPPORT_EMAIL || 'support@beginbright.org';
export const PRODUCT_WEBSITE = process.env.REACT_APP_PRODUCT_WEBSITE || 'https://www.mybeginbright.org';
export const PRODUCT_PLATFORM = process.env.REACT_APP_PRODUCT_PLATFORM || 'https://platform.mybeginbright.org';

export const APP_STORE_LINK = process.env.REACT_APP_APP_STORE_LINK || 'https://apps.apple.com/ni/app/bounceback-for-educators/id6739311418?l=en-GB';
export const GOOGLE_PLAY_LINK = process.env.REACT_APP_GOOGLE_PLAY_LINK || 'https://play.google.com/store/apps/details?id=com.bounceback.app';